document.addEventListener('DOMContentLoaded', () => {
  // For every product card on the page
  document.querySelectorAll('.card').forEach((card) => {
    const productRoot = card.closest('product-card') || card; // theme-safe root
    const wrap = card.querySelector('.bd-sample-order-wrap'); // your sample wrapper

    // Helpers
    const getLinks = () => productRoot.querySelectorAll('.js-prod-link');
    const setLinksVariant = (variantId) => {
      getLinks().forEach((link) => {
        try {
          const u = new URL(link.href, location.origin);
          u.searchParams.set('variant', String(variantId));
          link.href = u.pathname + u.search; // keep relative path
        } catch {
          // Fallback if link.href can't be parsed (unlikely)
          const base = link.href.split('?variant=')[0];
          link.href = `${base}?variant=${variantId}`;
        }
      });
    };

    /*
     * The sample CTA has to follow the swatch, not just point at the new variant.
     * Setting only data-variant-id was the BD_126496 bug: the button kept the
     * label and the data-action of whichever colourway the card first rendered,
     * so a card that opened on an "Available" colour went on saying "Add a Free
     * Sample" after the shopper picked a "Please Call" one — and the click
     * handler trusted that stale action and added the sample anyway.
     *
     * The status comes off the swatch itself (see
     * snippets/product-card-swatches.liquid) and is republished on the wrap,
     * which is where assets/bd-sample-order.js reads it from. Relabelling is left
     * to that file so the rules live in one place.
     */
    const setSampleVariant = (variantId, samplesOffered) => {
      if (!wrap) return;
      wrap.dataset.lastVariantId = String(variantId); // cache for click handler

      const btn = wrap.querySelector('.js-sample-order');
      if (btn) btn.dataset.variantId = String(variantId);

      if (typeof samplesOffered === 'string' && samplesOffered !== '') {
        wrap.dataset.initialSamplesOffered = samplesOffered;
      } else {
        // An unknown status must not inherit the last one it happened to show.
        delete wrap.dataset.initialSamplesOffered;
      }

      wrap.dispatchEvent(new CustomEvent('bd:sample:variant-change', { bubbles: true }));
    };

    // Resolve variant id from a changed control
    const resolveVariantIdFromControl = (el) => {
      // .opt-btn radios: prefer data-variant-id, else value on a dataset
      if (el && el.matches('.opt-btn')) {
        return el.dataset.variantId || el.value || el.getAttribute('value') || null;
      }
      // <select name="id"> (some themes)
      if (el && el.matches('select[name="id"]')) {
        return el.value || null;
      }
      // <input type="radio" name="id">
      if (el && el.matches('input[name="id"]')) {
        return el.value || null;
      }
      // Label carrying dataset
      const label = el && el.closest('label');
      if (label && label.dataset && label.dataset.variantId) {
        return label.dataset.variantId;
      }
      return null;
    };

    // Status travels on the control that changed it. A <select> carries it on the
    // chosen <option>, everything else on itself.
    const resolveSamplesOfferedFromControl = (el) => {
      if (!el) return undefined;
      if (el.tagName === 'SELECT') {
        const opt = el.options[el.selectedIndex];
        return opt ? opt.dataset.samplesOffered : undefined;
      }
      return el.dataset.samplesOffered;
    };

    // 1) RADIO SWATCHES
    card.querySelectorAll('.opt-btn').forEach((swatch) => {
      // Some themes use click, others fire change — listen to both
      const handler = () => {
        const variantId = resolveVariantIdFromControl(swatch);
        if (!variantId) return;
        setLinksVariant(variantId);
        setSampleVariant(variantId, resolveSamplesOfferedFromControl(swatch));

        // Optional: update small UI bits if you have them
        const titleEl = card.querySelector('.js-variant-title');
        if (titleEl) titleEl.textContent = swatch.value || swatch.dataset.value || titleEl.textContent;

        const skuEl = card.querySelector('.js-variant-sku');
        if (skuEl) skuEl.textContent = swatch.closest('label')?.dataset?.sku || swatch.dataset.sku || skuEl.textContent;
      };
      swatch.addEventListener('change', handler);
      swatch.addEventListener('click', handler);
    });

    // 2) SELECT-BASED PICKERS (either variant id or options)
    const idSelect = card.querySelector('select[name="id"]');
    if (idSelect) {
      idSelect.addEventListener('change', () => {
        const variantId = resolveVariantIdFromControl(idSelect);
        if (!variantId) return;
        setLinksVariant(variantId);
        setSampleVariant(variantId, resolveSamplesOfferedFromControl(idSelect));
      });
    }

    // 3) INPUT RADIO FOR name="id" (some themes render these)
    card.querySelectorAll('input[type="radio"][name="id"]').forEach((inp) => {
      inp.addEventListener('change', () => {
        const variantId = resolveVariantIdFromControl(inp);
        if (!variantId) return;
        setLinksVariant(variantId);
        setSampleVariant(variantId, resolveSamplesOfferedFromControl(inp));
      });
    });

    // 4) INITIALIZE from link ?variant= if present (page load)
    (() => {
      const firstLink = getLinks()[0];
      if (!firstLink) return;

      /*
       * Liquid already rendered the status of the variant the card opened on, so
       * this must not blank it. Prefer the swatch that matches the variant in the
       * link; if there is no such swatch, keep what the server said rather than
       * replacing a known status with nothing.
       */
      const statusFor = (variantId) => {
        const swatch = card.querySelector(`.opt-btn[data-variant-id="${variantId}"]`);
        const fromSwatch = swatch ? swatch.dataset.samplesOffered : undefined;
        if (typeof fromSwatch === 'string' && fromSwatch !== '') return fromSwatch;
        return wrap ? wrap.dataset.initialSamplesOffered : undefined;
      };

      let vid = null;
      try {
        vid = new URL(firstLink.href, location.origin).searchParams.get('variant');
      } catch {
        const m = firstLink.href.match(/[?&]variant=(\d+)/);
        vid = m ? m[1] : null;
      }
      if (vid) setSampleVariant(vid, statusFor(vid));
    })();
  });
});
